import React, { useState } from "react";
import axios from "axios";
import "./Login.css";

const apiUrl = "https://hklighting.co.kr";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${apiUrl}/login`, {
        username,
        password,
      });

      const { token } = response.data;
      localStorage.setItem("token", token);

      alert("로그인되었습니다.");

      window.location.href = "/";
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "로그인 실패");
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img
          src="/assets/images/logoColor.png"
          alt="logo"
          className="login-logo"
        />
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="username">아이디</label>
            <input
              type="text"
              id="username"
              placeholder="아이디"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <label htmlFor="password">비밀번호</label>
            <input
              type="password"
              id="password"
              placeholder="비밀번호"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {errorMessage && <p className="error-message">{errorMessage}</p>}
          <button type="submit" className="login-button">
            로그인
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
